// extracted by mini-css-extract-plugin
export default {"emailView":"TemplateView_emailView__0X2d+"};